import { create } from "zustand";
import { RydTimelineSelection } from "../components/widgets/rolls/RydTimelineHeader";


export type TimelineSelectionStore = {
    timelineSelection?: RydTimelineSelection;
    setTimelineSelection: (selection?: RydTimelineSelection) => void;
}

export const timelineSelectionStore = create<TimelineSelectionStore>((set) => ({
    timelineSelection: undefined,
    setTimelineSelection: (selection?: RydTimelineSelection) => {
        set({ timelineSelection: selection })
    }
}));

export const useTimelineSelectionStore = () => {
    return timelineSelectionStore((state) => ({
        timelineSelection: state.timelineSelection,
        setTimelineSelection: state.setTimelineSelection
    }));
}

export const useTimelineSelection = () => {
    return timelineSelectionStore((state) => state.timelineSelection);
}

export const useSetTimelineSelection = () => {
    return timelineSelectionStore((state) => state.setTimelineSelection);
}